import { render, staticRenderFns } from "./DeductionsPlanDetailsTable.vue?vue&type=template&id=05459064&"
import script from "./DeductionsPlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports